import { React, useEffect, useState } from 'react';
import {
    Chart as ChartJS,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bubble } from 'react-chartjs-2';
import bg_barrel_right_line from '../../style/images/bg_barrel_right_line.png';
import bg_barrel_left_person from '../../style/images/bg_barrel_left_person.png';
import bg_barrel_right_unit from '../../style/images/bg_barrel_right_unit.png';
import { hboption, hitterBarrelOptions, hitterBarrlPlugins, testplugins } from './HitterBarrelOptions';

ChartJS.register(LinearScale, PointElement, Tooltip, Legend);
export function HitBarrelChart({pData}) {
    const [size, setSize] = useState({
        x: window.innerWidth,
        y: window.innerHeight
    });
    const [data, setData] = useState({datasets:[]})

    const [cSize, setCSize] = useState({
        width: 750,
        height: 450
    })
    const updateSize = () =>
        setSize({
            x: window.innerWidth,
            y: window.innerHeight
        });
    useEffect(() => (window.onresize = updateSize), []);

    useEffect(() => {
        // console.log(size)
        // setCSize({width :width*2, height:width*2+200})
    }, [size])

    useEffect(() => {
        var pitchData = JSON.parse(JSON.stringify(pData))
        //console.log(pData)
        //console.log(JSON.stringify(pData))
        // console.log(pitchData)

        var empty_array = [];
        var pitches = [
            pitchData.Barrel !== undefined ? pitchData.Barrel : empty_array,
            pitchData['Flare-or-Burner'] !== undefined ? pitchData['Flare-or-Burner'] : empty_array,
            pitchData['Poorly-Topped'] !== undefined ? pitchData['Poorly-Topped'] : empty_array,
            pitchData['Poorly-Under'] !== undefined ? pitchData['Poorly-Under'] : empty_array,
            pitchData['Solid-Contact'] !== undefined ? pitchData['Solid-Contact'] : empty_array,
            pitchData['Weak-Contact'] !== undefined ? pitchData['Weak-Contact'] : empty_array,
            pitchData.CT !== undefined ? pitchData.CT : empty_array,
            pitchData.SC !== undefined ? pitchData.SC : empty_array,
            pitchData.SFF !== undefined ? pitchData.SFF : empty_array,
            pitchData.KN !== undefined ? pitchData.KN : empty_array,
            pitchData.OT !== undefined ? pitchData.OT : empty_array,
            pitchData.UN !== undefined ? pitchData.UN : empty_array,
        ];

        var colors = [
            "#ed1b24",//Barrel
            "#f8cbac",//Flare-or-Burner
            "#e2efdb",//Poorly-Topped
            "#ddebf6",//Poorly-Under
            "#fdcfd1",//Solid-Contact
            "#fff2cd",//Weak-Contact
        ];
        var datasets = [];
        for (var i = 0; i < pitches.length; i++) {
            datasets.push({
                pointBackgroundColor: colors[i],
                borderWidth: 0.5,
                borderColor: "#000000",
                data: pitches[i],

            });
        }


        setData({datasets: datasets})
    }, [pData])

    return <>
        <div className="chart_barrel" style={{ background: " none" }}>
            <Bubble options={hitterBarrelOptions} plugins={hitterBarrlPlugins} data={data} />
            <div class="chart_barrel_legend">
                <div class="barrel_br_list"></div> Barrel<br />
                <div class="barrel_fb_list"></div> Flare-or-Burner<br />
                <div class="barrel_pt_list"></div> Topped<br />
                <div class="barrel_pu_list"></div> Under<br />
                <div class="barrel_sc_list"></div> Solid-Contact<br />
                <div class="barrel_wc_list"></div> Weak-Contact<br />
            </div>
        </div>
    </>
}
